import moment from "moment";
import { PropsWithChildren, useEffect, useState } from "react";


interface Props extends PropsWithChildren {
    locales: Record<string, any>
}

function updateMomemtLocales(locales: Props['locales']){
    const currentLocale = moment.locale()
    for(const [lng, configuration] of Object.entries(locales)){
        moment.updateLocale(lng, configuration)
    }
    moment.locale(currentLocale)
}

export function MomentProvider({locales, children}: Props){
    const [] = useState(updateMomemtLocales(locales))

    useEffect(() => {
        updateMomemtLocales(locales)
    }, [locales])
    return (
        <>
            {children}
        </>
    )
}

export function createMomentProvider(locales: Props['locales']){
    return ({children}: PropsWithChildren) => (
        <MomentProvider {...{locales, children}}/>
    )
}